<template>
    <div class="news">
        <news-header>新闻速递</news-header>
        <div class="container">
            <!-- 新闻资讯 -->
            <section class="public">
                <div class="box">
                    <span class="title">新闻资讯</span>
                    <span class="line"></span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <div class="swiper">
                    <swiper :options="swiperOption" v-if="swiperList.length">
                        <swiper-slide v-for="item in swiperList" :key="item.id">
                            <router-link tag="div" class="slideBox" :to="{name: 'Detail',query:{id: item.id,mode: 'ARTICLE'}}">
                                <img :src="item.image" alt="">
                                <p class="dis">{{ item.text }}</p>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-pagination"  slot="pagination"></div>
                    </swiper> 
                </div>
                <div class="content">
                <ul class="newsList">
                    <router-link 
                        tag="li"
                        class="lis"
                        v-for="item in swiperList" 
                        :key="item.id"
                        :to="{name: 'Detail',query: {id:item.id,mode:'ARTICLE'}}"
                    >
                        <p class="title">
                            {{item.title}}
                        </p>
                        <p class="time">{{item.createDate.split(' ')[0]}}</p>
                    </router-link>
                        
                </ul>
                </div>
            </section>
            <!-- 视频新闻 -->
            <section class="public">
                <div class="box">
                    <span class="title">视频新闻</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: '8d2db18bf26b445c8c6d84a7b84a5d3d ',title: '视频新闻',mode: 'VIDEO'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <div class="content">
                    <ul class="videoList">
                        <li class="videolis" 
                            v-for="item in videoList" 
                            :key="item.id"
                            @click="handleItemClick(item)"
                        >
                            <div class="icon">
                                <img :src="item.imageSrc" alt="">
                            </div>
                            <p class="words">
                                {{item.name}}
                            </p>
                        </li>
                    </ul>
                
                </div>
            </section>
            <!-- 协会动态 -->
            <section class="public">
                <div class="box">
                    <span class="title">协会动态</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: 'f6a6e98330b44f609cd64eb2964967f5',title: '协会动态'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="doingList">
                    <router-link 
                        tag="li"
                        class="lis"
                        v-for="item in dynamicList" 
                        :key="item.id"
                        :to="{name:'Detail',query:{id: item.id, mode: 'ARTICLE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{item.title}}
                            </p>
                            <p class="times">{{item.createDate.split(' ')[0]}}</p>
                        </div>
                    </router-link>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import NewsHeader from '../../components/Header';
export default {
    name: 'news',
    components: {
        NewsHeader
    },
    data() {
        return {
            swiperList: [],
            swiperOption: {
                observer:true,
                observeParents:true,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass : 'my-bullet',
                    bulletActiveClass: 'my-bullet-active',
                },
                on:{
                    paginationUpdate: (e) =>{
                        this.selectNewsList = this.swiperList[e.realIndex]
                    }
                },
            },
            dynamicList: [],
            videoList: []
        }
    },
    mounted() {
        // 获取新闻资讯轮播内容
        this.getNewsList()
        // 协会动态
        this.getDynamicList()
        // 视频新闻
        this.getVideoList()
    },
    methods: {
        // 获取新闻资讯
        getNewsList() {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/mobilecarousel',
                method: 'GET',
            }).then(res => {
                if(res.data.code == 0){
                    this.swiperList = res.data.xwzxThree
                    console.log(this.swiperList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 协会动态列表
        getDynamicList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: 'f6a6e98330b44f609cd64eb2964967f5 ',
                    pageNo,
                    pageSize,
                    contentType: 'ARTICLE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.dynamicList = res.data.page.list
                    console.log(this.dynamicList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 视频新闻
        getVideoList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '8d2db18bf26b445c8c6d84a7b84a5d3d  ',
                    pageNo,
                    pageSize,
                    contentType: 'VIDEO'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.videoList = res.data.page.list
                    console.log(this.videoList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 点击视频
        handleItemClick(item){
            console.log(item);
            this.$router.push({name:'Video',query: {realUrl: item.realUrl}})
        }
    },
}
</script>

<style scoped>
.news{
    background: #F2F3F7;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 新闻资讯 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem 0;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    width: 5.6rem;
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: auto;
}
.public .box .more{
    position: absolute;
    right: .14rem;
    color: #666;
    top: 50%;
    transform: translateY(-70%);
    padding: .1rem;
    display: flex;
    align-items: center
}

.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .swiper{
    height: 3.3rem;
}
.public .swiper .swiper-slide{
    height: 3.3rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.slideBox{
    width: 100%;
    display: flex;
    align-items: center;
    height: 3.3rem;
}
.public .swiper .swiper-slide img{
    width: 100%;
    max-height: 100%;
}
.public .swiper >>> .my-bullet{
    background: #333;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 4px;
}
.public .swiper >>> .my-bullet-active{
    width: 20px;
    border-radius: 3px;
    background: #fff;
    opacity: 1;
}
.dis{
    width: 100%;
    height: .5rem;
    line-height: .5rem;
    position: absolute;
    background: rgba(0,0,0,.7);
    color: #fff;
    bottom: 0;
    left: 0;
    padding-left: .16rem;
    box-sizing: border-box;
}
.public .content {
    padding-bottom: .2rem;
}
.public >>> .swiper-pagination{
    height: .5rem;
    text-align: right;
    bottom: 0 !important;
    line-height: .5rem;
}
.newsList{
    padding: .2rem 0;
}
.newsList .lis {
    height: .6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.newsList .lis .title{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 6rem;
}
.newsList .lis .time{
    color: #333;
    width: 2rem;
}
/* 视频咨询 */
.videoList{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.videolis{
    width: 3.36rem;
    height: 2.72rem;
    margin-bottom: .2rem;
    position: relative;
}

.videoList .videolis .icon{
    width: 3.36rem;
    height: 1.9rem;
}
.videoList .videolis .icon img{
    width: 100%;
    height: 100%;
}
.videoList .videolis .words{
    line-height: 1.5;
    margin-top: .1rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
/* 协会动态 */
.public .doingList .lis{
    display: flex;
    margin-bottom: .3rem;
}
.public .doingList .lis .iconBox{
    width: 1.8rem;
    height: 1.2rem;
    margin-right: .2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.public .doingList .lis .iconBox img{
    width: 100%;
    max-height: 100%
}
.public .doingList .lis .rt{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.public .doingList .lis .rt .doingTitle{
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.public .doingList .lis .rt .times{
    color: #999;
}

</style>